import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import DatePicker from "react-datepicker";
import axios from "axios";
import {useHistory} from 'react-router-dom';
import { API_URL } from "../../constent";
import {
  Block,
  BlockHeadContent,
  BlockTitle,
  BlockBetween,
  BlockHead,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  TooltipComponent,
  PaginationComponent,
  PreviewAltCard,
  Row,
  Col,
  RSelect,
} from "../../components/Component";
import { getDateStructured } from "../../utils/Utils";
import { UncontrolledDropdown, ModalFooter, FormGroup, ModalHeader, Button, Modal, ModalBody } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom/cjs/react-router-dom";

const SearchList = () => {

  const [startDate, setStartDate] = useState(new Date());

  const [modalForm, setModalForm] = useState(false);
  const [data, setData] = useState([]);
  const [smOption, setSmOption] = useState(false);
  const [smCategory, setSmCategory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getload, getLoading] = useState(false);
  const [btnloading, setBtnLoading] = useState(false);

  const history = useHistory();

  const [view, setView] = useState({
    add: false,
    details: false,
  });
  const [onSearchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [selectedStage, setselectedStage] = useState([]);
  const [savestage, saveStage] = useState("");
  const [itemid, setItemid] = useState(0);

  var userData = JSON.parse(localStorage.getItem('userData'));
  const getuserid = userData?.[0]?.id;
  const role = userData?.[0]?.role;


  // Changing state value when searching name

  useEffect(() => {
        axios.post(`${API_URL}getstage`).then((result)=>
        {
            console.log(result.data);
            setselectedStage(result.data);
            getLoading(false);
        })
  }, [btnloading]);

  if (getload) {
    return(
       <>
         <p>Loading....</p>
       </>
    ) 
} 


  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function to delete a Order
  const deleteOrder = (id) => {
    let defaultData = data;
    defaultData = defaultData.filter((item) => item.id !== id);
    setData([...defaultData]);
  };


  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const toggleForm= (id) =>{
    setItemid(id);
    setModalForm(!modalForm);
  }

  const onFormSubmit = () => {
    

    const formdata = new FormData();

    formdata.append('option' , smOption);
    formdata.append('searchText' , onSearchText);
    formdata.append('searchCategory' , smCategory);

    setLoading(true);

    axios.post( `${API_URL}getproposersearch`, formdata)
    .then((response)=>{

        console.log(response.data);
        setData(response.data);
        getLoading(false);
        setLoading(false);

    })
  };


  function submitdata(){

    let date = new Date(startDate);
    let formattedDate = date.getFullYear() + '-' +
                        ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                        ('0' + date.getDate()).slice(-2);

    const formdata = new FormData()
    formdata.append('itemid' , itemid)
    formdata.append('getuserid' , getuserid)
    formdata.append('startDate' , formattedDate)
    formdata.append('savestage' , savestage)

    axios.post(`${API_URL}forwardstage` , formdata)
      .then((response)=>{
          console.log(response.data);
          if(response.data.status === 1){
              setBtnLoading(false);
              toggleForm();
              window.location.reload();
          }else{
              setBtnLoading(false);
              toggleForm();
              alert(response.data.msg);
          }
      })

  }

  return (
    <React.Fragment>
      <Head title="Main List"></Head>
      <Content>
        <BlockHead size="sm">
        <Row className="g-gs">
                <Col sm="12">
                     <p className="top_head_css">Search</p>
                </Col>
          </Row>
        <Row className="g-gs">

        <Col sm="3">
                    <div className="input_bg_css">
                        <select
                            className="form-select form-control"
                            onChange={(e) => {
                              setSmCategory(e.target.value);
                            }}
                            value={smCategory}
                        >
                            <option value="0">Select Category</option>
                            <option value="1">HEALTH</option>
                            <option value="4">MOTOR</option>
                            <option value="10">NON MOTOR</option>
                        </select>
                    </div>
                </Col>

                <Col sm="3">
                    <div className="input_bg_css">
                        <select
                            className="form-select form-control"
                            onChange={(e) => {
                              setSmOption(e.target.value);
                            }}
                            value={smOption}
                        >
                            <option value="0">Select</option>
                            <option value="1">CURRENT POLICY NUMBER</option>
                            <option value="2">VEHICLE NUMBER</option>
                            <option value="3">MOBILE NUMBER</option>
                            <option value="4">NAME OF PROPOSER</option>
                            <option value="5">DATE OF BIRTH</option>
                            <option value="6">POLICY PERIOD</option>
                        </select>
                    </div>
                </Col>

                <Col sm="4">
                     <div className="input_bg_css_button">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Please enter value"
                            onChange={(e) => {  onFilterChange(e); }}
                            value={onSearchText}
                            name="search"
                            autoComplete="off"
                            autoFocus
                        />
                        <button className="btn btn-primary" onClick={() => onFormSubmit()}>
                            <Icon name="search"></Icon>
                        </button>
                     </div>
                </Col>

          </Row>
        </BlockHead>

        <Block>
        <div className="card">
        {
          smCategory === '1' ? (
            currentItems.length > 0 ? (
        <div className="table-responsive card-inner">
                <table className="table table-bordered table-striped">
                    <thead>
                    <tr>
                        <th>PROPOSER</th>
                        <th>ADDRESS OF CORRESPONDENCE</th>
                        <th>POLICY ADDRESS</th>
                        <th>AADHAR NUMBER</th>
                        <th>PAN NUMBER</th>
                        <th>EMAIL ID</th>
                        <th>MOBILE NUMBER</th>
                        <th>WHATSAPP NUMBER</th>
                        <th>DATE OF BIRTH</th>
                        <th>TYPE OF POLICY</th>
                        <th>NAME OF PRODUCT</th>
                        <th>RIDERS</th>
                        <th>DETAILS OF INSURED</th>
                        <th>ANNUAL INCOME</th>
                        <th>SUM INSURED</th>
                        <th>BONUS</th>
                        <th>ADDITIONAL BONUS</th>
                        <th>DEDUCTIBLE</th>
                        <th>FLOATER/INDIVIDUAL</th>
                        <th>PRE EXISTING</th>
                        <th>INSURED SINCE</th>
                        <th>MOROTORIAM PERIOD</th>
                        <th>POLICY START DATE</th>
                        <th>POLICY END DATE</th>
                        <th>PREVIOUS POLICY NUMBER</th>
                        <th>NAME OF INSURER</th>
                        <th>CURRENT POLICY NUMBER</th>
                        <th>NAME OF INSURER</th>
                        <th>NET PREMIUM</th>
                        <th>LOADING</th>
                        <th>GST</th>
                        <th>TOTAL PREMIUM</th>
                        <th>NOMINEE DETAILS</th>
                        <th>NOTES</th>
                        <th>DOCS</th>
                        <th>ACTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems.length > 0
                        ? currentItems.map((item) => (
                            <tr key={item.id}>
                            <td>{item.proposer}</td>
                            <td>{item.address}</td>
                            <td>{item.policy_address}</td>
                            <td>{item.aadhar_number}</td>
                            <td>{item.pan_number}</td>
                            <td>{item.email_id}</td>
                            <td>{item.phone_number}</td>
                            <td>{item.whatsapp_number}</td>
                            <td>{item.dob}</td>
                            <td>{item.type_policy}</td>
                            <td>{item.product}</td>
                            <td>{item.riders}</td>
                            <td>{item.details_insured}</td>
                            <td>{item.annual_income}</td>
                            <td>{item.sum_insured}</td>
                            <td>{item.bonus}</td>
                            <td>{item.add_bonus}</td>
                            <td>{item.deductible}</td>
                            <td>{item.floater}</td>
                            <td>{item.pre_exixting}</td>
                            <td>{item.insured_since}</td>
                            <td>{item.moto_preiod}</td>
                            <td>{item.policy_start_date}</td>
                            <td>{item.policy_end_date}</td>
                            <td>{item.pre_policy_no}</td>
                            <td>{item.pre_policy_insurer}</td>
                            <td>{item.current_policy_no}</td>
                            <td>{item.current_policy_insurer}</td>
                            <td>{item.net_premium}</td>
                            <td>{item.loading}</td>
                            <td>{item.gst}</td>
                            <td>{item.total_premium}</td>
                            <td>{item.nominee}</td>
                            <td>{item.note}</td>
                            <td>
                              {Array.isArray(item.docs) ? (
                                item.docs.map((doc, index) => (
                                  <a href={doc} key={index} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                    View
                                  </a>
                                ))
                              ) : item.docs !== null && item.docs !== "" ? (
                                <a href={item.docs} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                  View
                                </a>
                              ) : (
                                <span>No Document</span>
                              )}
                            </td>
                            <td>
                            <a href={`/editmainsheethealth/${item.id}/${item.category_id}/${item.policy_type}`} target="_blank" rel="noopener noreferrer">
                                    <Button className="btn btn-sm" color="primary">
                                      Edit
                                    </Button>
                                  </a>                               
                            </td>
                            </tr>
                        ))
                        : (
                        <tr>
                            <td colSpan="13" className="text-center">
                            No data available
                            </td>
                        </tr>
                        )}
                    </tbody>
                </table>
                </div>
                ):(
                    null
                )):(
                  null
                )}

   {
          smCategory === '4' ? (
            currentItems.length > 0 ? (
        <div className="table-responsive card-inner">
                <table className="table table-bordered table-striped">
                    <thead>
                    <tr>
                        <th>PROPOSER</th>
                        <th>ADDRESS OF CORRESPONDENCE</th>
                        <th>POLICY ADDRESS</th>
                        <th>EMAIL ID</th>
                        <th>MOBILE NUMBER</th>
                        <th>WHATSAPP NUMBER</th>
                        <th>AADHAR NUMBER</th>
                        <th>PAN NUMBER</th>
                        <th>VEHICLE REGISTRATION  NUMBER</th>
                        <th>MAKE</th>
                        <th>CHASIS NUMBER</th>
                        <th>ENGINE NUMBER</th>
                        <th>REGISTRATION VALIDITY DATE</th>
                        <th>CUBIC CAPACITY</th>

                        <th>YEAR OF MANUFACTURE</th>
                        <th>COLOR</th>
                        <th>SEATING CAPACITY</th>
                        <th>GSTIN</th>
                        <th>FUEL TYPE</th>
                        <th>PREVIOUS POLICY NUMBER</th>
                        <th>NAME OF INSURER</th>
                        <th>CURRENT POLICY NUMBER</th>
                        <th>NAME OF INSURER</th>
                        <th>POLICY STATUS</th>
                        <th>DOCS</th>
                        <th>ACTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems.length > 0
                        ? currentItems.map((item) => (
                            <tr key={item.id}>
                            <td>{item.proposer}</td>
                            <td>{item.address}</td>
                            <td>{item.policy_address}</td>
                            <td>{item.email_id}</td>
                            <td>{item.phone_number}</td>
                            <td>{item.whatsapp_number}</td>
                            <td>{item.aadhar_number}</td>
                            <td>{item.pan_number}</td>
                            <td>{item.vehicle_reg_number}</td>
                            <td>{item.make}</td>
                            <td>{item.chasis_number}</td>
                            <td>{item.engine_number}</td>
                            <td>{item.reg_validity_date}</td>
                            <td>{item.cubic_capacity}</td>
                            <td>{item.year_manuf}</td>
                            <td>{item.color}</td>
                            <td>{item.seating_capacity}</td>
                            <td>{item.gstin}</td>
                            <td>{item.fuel_type}</td>
                            <td>{item.pre_policy_no}</td>
                            <td>{item.pre_policy_insurer}</td>
                            <td>{item.current_policy_no}</td>
                            <td>{item.current_policy_insurer}</td>
                            <td>{item.policy_status === '1' ? (
                                <div>ACTIVE</div>
                                ) : item.policy_status === '2' ? (
                                <div>NEW INACTIVE</div>
                                ) : item.policy_status === '3' ? (
                                  <div>CANCELLED</div>
                                ):(
                                 <div>EXPIRED</div>
                                )}</td>
                                <td>
                                    {Array.isArray(item.docs) ? (
                                      item.docs.map((doc, index) => (
                                        <a href={doc} key={index} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                          View
                                        </a>
                                      ))
                                    ) : item.docs !== null && item.docs !== "" ? (
                                      <a href={item.docs} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                        View
                                      </a>
                                    ) : (
                                      <span>No Document</span>
                                    )}
                                  </td>
                                <td>
                                  <a href={`/editmainsheet/${item.id}/${item.category_id}/${item.policy_type}`} target="_blank" rel="noopener noreferrer">
                                    <Button className="btn btn-sm" color="primary">
                                      Edit
                                    </Button>
                                  </a>                               
                                </td>
                                
                            </tr>
                        ))
                        : (
                        <tr>
                            <td colSpan="13" className="text-center">
                            No data available
                            </td>
                        </tr>
                        )}
                    </tbody>
                </table>
                </div>
                ):(
                    null
                )):(
                  null
                )}

{
          smCategory === '10' ? (
            currentItems.length > 0 ? (
        <div className="table-responsive card-inner">
                <table className="table table-bordered table-striped">
                    <thead>
                    <tr>
                        <th>PROPOSER</th>
                        <th>ADDRESS OF CORRESPONDENCE</th>
                        <th>POLICY ADDRESS</th>
                        <th>RISK LOCATION ADDRESS</th>
                        <th>EMAIL ID</th>
                        <th>MOBILE NUMBER</th>
                        <th>WHATSAPP NUMBER</th>
                        <th>GSTIN NUMBER</th>
                        <th>AADHAR NUMBER</th>
                        <th>PAN NUMBER</th>
                        <th>TYPE OF POLICY</th>
                        <th>COVERAGE</th>
                        <th>FIRE TARIFF CODE</th>
                        <th>RISK CATEGORY (AS PER THE TARIFF CODE)</th>
                        <th>SUM INSURED</th>
                        <th>SUM INSURED BREAKUP</th>
                        <th>NET PREMIUM</th>
                        <th>GST</th>
                        <th>TOTAL PREMIUM</th>
                        <th>POLICY START DATE</th>
                        <th>POLICY END DATE</th>
                        <th>PREVIOUS POLICY NUMBER</th>
                        <th>NAME OF INSURER</th>
                        <th>CURRENT POLICY NUMBER</th>
                        <th>NAME OF INSURER</th>
                        <th>AGENT</th>
                        <th>MODE OF PAYMENT</th>
                        <th>PAYMENT DETAILS</th>
                        <th>STATUS OF POLICY</th>
                        <th>NOMINEE DETAILS</th>
                        <th>NOTES</th>
                        <th>DOCS</th>
                        <th>ACTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems.length > 0
                        ? currentItems.map((item) => (
                            <tr key={item.id}>
                            <td>{item.proposer}</td>
                            <td>{item.address}</td>
                            <td>{item.policy_address}</td>
                            <td>{item.risk_location_address}</td>
                            <td>{item.email_id}</td>
                            <td>{item.phone_number}</td>
                            <td>{item.whatsapp_number}</td>
                            <td>{item.aadhar_number}</td>
                            <td>{item.pan_number}</td>
                            <td>{item.gst_number}</td>
                            <td>{item.type_policy}</td>
                            <td>{item.coverage}</td>
                            <td>{item.fire_trf_code}</td>
                            <td>{item.risk_code}</td>
                            <td>{item.sum_insured}</td>
                            <td>{item.sum_insured_breakup}</td>
                            <td>{item.net_premium}</td>
                            <td>{item.gst}</td>
                            <td>{item.total_premium}</td>
                            <td>{item.policy_start_date}</td>
                            <td>{item.policy_end_date}</td>
                            <td>{item.pre_policy_no}</td>
                            <td>{item.pre_policy_insurer}</td>
                            <td>{item.current_policy_no}</td>
                            <td>{item.current_policy_insurer}</td>
                            <td>{item.agent}</td>
                            <td>{item.mode_of_payment}</td>
                            <td>{item.payment_details}</td>
                            <td>{item.policy_status === '1' ? (
                                <div>ACTIVE</div>
                                ) : item.policy_status === '2' ? (
                                <div>NEW INACTIVE</div>
                                ) : item.policy_status === '3' ? (
                                  <div>CANCELLED</div>
                                ):(
                                 <div>EXPIRED</div>
                                )}</td>
                            
                            <td>{item.nominee}</td>
                            <td>{item.note}</td>      
                            <td>
                                    {Array.isArray(item.docs) ? (
                                      item.docs.map((doc, index) => (
                                        <a href={doc} key={index} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                          View
                                        </a>
                                      ))
                                    ) : item.docs !== null && item.docs !== "" ? (
                                      <a href={item.docs} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                        View
                                      </a>
                                    ) : (
                                      <span>No Document</span>
                                    )}
                                  </td>
                            <td>
                              <a href={`/editmainsheetnonmotor/${item.id}/${item.category_id}/${item.policy_type}`} target="_blank" rel="noopener noreferrer">
                                <Button className="btn btn-sm" color="primary">
                                  Edit
                                </Button>
                              </a>

                            </td>
                            </tr>
                        ))
                        : (
                        <tr>
                            <td colSpan="13" className="text-center">
                            No data available
                            </td>
                        </tr>
                        )}
                    </tbody>
                </table>
                </div>
                ):(
                    null
                )):(
                  null
                )}


            </div>
        </Block>
        
        <Modal isOpen={modalForm} toggle={toggleForm}>
                  <ModalHeader
                    toggle={toggleForm}
                    close={
                      <button className="close" onClick={toggleForm}>
                        <Icon name="cross" />
                      </button>
                    }
                  >
                    Forward Stage
                  </ModalHeader>
                  <ModalBody>
                    <form>
                      <FormGroup>
                        <label className="form-label" htmlFor="full-name">
                          Stage
                        </label>
                        <RSelect
                        name="stage"
                        options={selectedStage}
                        onChange={(e) => saveStage(e.value)}
                        defaultValue={savestage}
                        />
                      </FormGroup>
                      <FormGroup>
                        <label className="form-label" htmlFor="email">
                          Date
                        </label>
                        <DatePicker selected={startDate} onChange={setStartDate} className="form-control date-picker" />
                      </FormGroup>
                      
                      <FormGroup>
                        <Button disabled={btnloading} color="primary" type="button" onClick={()=>submitdata()} size="lg">
                        {btnloading ? 'Loading...' : 'Save'}
                        </Button>
                      </FormGroup>
                    </form>
                  </ModalBody>
    
                </Modal>

      </Content>
    </React.Fragment>
  );
};

export default SearchList;
